<svg width="50" height="50" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_452_1107)">
    <g clip-path="url(#clip0_452_1107)">
      <rect x="4.75" y="2.75" width="34" height="34" rx="17" fill="white" />
      <path
        d="M15.1834 11.841L19.374 15.486C19.9195 15.9604 19.9194 16.8076 19.3738 17.2819L15.1985 20.9121"
        stroke="#1A73E8"
        stroke-width="3.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.41 11.841L28.6006 15.486C29.146 15.9604 29.146 16.8076 28.6004 17.2819L24.425 20.9121"
        stroke="#1A73E8"
        stroke-width="3.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8359 28.1621C19.7394 30.3719 23.7608 30.3719 26.6643 28.1621"
        stroke="#1A73E8"
        stroke-width="3.1875"
        stroke-linecap="round"
      />
    </g>
    <rect x="4.75" y="2.75" width="34" height="34" rx="17" stroke="#8FAFED" stroke-width="1.5" />
  </g>
  <defs>
    <filter
      id="filter0_d_452_1107"
      x="0"
      y="0"
      width="43.5"
      height="43.5"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="2" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.06 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_452_1107" />
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_452_1107" result="shape" />
    </filter>
    <clipPath id="clip0_452_1107">
      <rect x="4.75" y="2.75" width="34" height="34" rx="17" fill="white" />
    </clipPath>
  </defs>
</svg>
